import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAuthorityClaimMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteAuthorityClaimMutation = { __typename?: 'mutation_root', delete_authority_claims_by_pk?: { __typename?: 'authority_claims', id: any } | null };


export const DeleteAuthorityClaimDocument = gql`
    mutation DeleteAuthorityClaim($id: uuid!) {
  delete_authority_claims_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAuthorityClaimMutationFn = Apollo.MutationFunction<DeleteAuthorityClaimMutation, DeleteAuthorityClaimMutationVariables>;

/**
 * __useDeleteAuthorityClaimMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorityClaimMutation, { data, loading, error }] = useDeleteAuthorityClaimMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAuthorityClaimMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthorityClaimMutation, DeleteAuthorityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthorityClaimMutation, DeleteAuthorityClaimMutationVariables>(DeleteAuthorityClaimDocument, options);
      }
export type DeleteAuthorityClaimMutationHookResult = ReturnType<typeof useDeleteAuthorityClaimMutation>;
export type DeleteAuthorityClaimMutationResult = Apollo.MutationResult<DeleteAuthorityClaimMutation>;
export type DeleteAuthorityClaimMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorityClaimMutation, DeleteAuthorityClaimMutationVariables>;